import styled from 'astroturf/react';

export const VeloCardAction = styled('div')`
  margin: 0rem 1rem 1rem 1rem;
  display: flex;
  justify-content: flex-end;
`;
